<template>
  <button class="btn" @click="onClicked" type><i :class=iconName></i>{{ buttonText }}</button>
</template>

<script>
export default {
  name: "Button",
  props: [
    "buttonText",
    "iconName"
  ],
  methods: {
    onClicked()
    {
      this.$emit("clicked");
    }
  }
}
</script>

<style lang="scss" scoped>
button
{
  background-color: $primary-blue;
  color: $font-light;

  width: 100%;
  height: 50px;

  font-size: $title-size;
  border-radius: 5px;

  i
  {
    margin-right: 0.5rem;
  }
}
</style>